(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slowlines-leathers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sl-leather-navigation')) {
    customElements.define('sl-leather-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.rebuild = () => {
          const nav = this.querySelector('nav');
          if (!nav) return;
          nav.querySelectorAll('a').forEach(link => link.remove());
          const stories = document.querySelectorAll('.sl-leather-story[id]');
          for (const story of stories) {
            const heading = story.querySelector('h2');
            if (!heading || !heading.textContent.trim()) continue;
            const link = document.createElement('a');
            link.href = '#' + story.id;
            link.textContent = heading.textContent.trim();
            nav.append(link);
          }
          nav.hidden = !nav.querySelector('a');
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.rebuild, { ...options, once: true });
        } else {
          this.rebuild();
        }
        for (const event of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
          document.addEventListener(event, this.rebuild, options);
        }
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
